import React, { useState, useMemo } from 'react';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import Select from '../../shared/Select';
import Button from '../../shared/Button';
import ModalSelect from '../../shared/modal-select/ModalSelect';

import { targetOptions, rangeOptions } from '../../../constants/setTurnsReporting';

import './styles.scss';

const SetTurnsForm = (props) => {
  const {
    kits = [],
    selectedKits = [],
    setSelectedKits,
    target,
    setTarget,
    range,
    setRange,
    onSubmit,
    loading,
  } = props;

  const [isOpen, toggleModal] = useState(false);

  const kitLabel = useMemo(() => {
    if (!selectedKits?.length) {
      return 'Select';
    }

    if (selectedKits.length === kits.length) {
      return 'All kits';
    }

    if (selectedKits.length === 1) {
      const kit = kits?.find((k) => k.id === selectedKits[0]);
      return kit?.kitId || '';
    }

    return `${selectedKits.length} kits selected`;
  }, [selectedKits, kits]);

  return (
    <div className='set-turns-form__container'>
      <div className='set-turns-form__field'>
        <div>Kit ID</div>
        <div className='set-turns-form__select-box' onClick={() => toggleModal(true)}>
          {kitLabel}
          <KeyboardArrowDownIcon style={{ fill: '#c6c8c9' }} />
        </div>

        <ModalSelect
          title='Select Kit'
          listTitle='Kits'
          options={kits}
          onChange={(value) => setSelectedKits(value || [])}
          selected={selectedKits}
          onClose={() => toggleModal(false)}
          isOpen={isOpen}
          field='kitId'
          extraField='name'
          selectAll
        />
      </div>
      <div className='set-turns-form__field'>
        <div>Performance Target (turns/month)</div>
        <Select
          value={target}
          onChange={setTarget}
          options={targetOptions}
        />
      </div>
      <div className='set-turns-form__field'>
        <div>Date Range</div>
        <Select
          value={range}
          onChange={setRange}
          options={rangeOptions}
        />
      </div>

      <div className='set-turns-form__button'>
        <Button
          onClick={onSubmit}
          disabled={loading || !selectedKits.length}
          loading={loading}
          text='Run Report'
        />
      </div>
    </div>
  )
};

export default SetTurnsForm;
